module.exports = __webpack_public_path__ + "static/13-af2c41c63029f118ead35991218dfc36.jpg";